import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/scroll";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import DestinationsMarquee from "@/components/DestinationsMarquee";
import Manifesto from "@/components/Manifesto";
import Destinations from "@/components/Destinations";
import Gallery from "@/components/Gallery";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Reviews from "@/components/Reviews";
import Faq from "@/components/Faq";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import ChatWidget from "@/components/ChatWidget";
import AuthPage from "@/pages/AuthPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";

const HomePage = () => (
  <main>
    <Hero />
    <DestinationsMarquee />
    <Manifesto />
    <Destinations />
    <Gallery />
    <Services />
    <Process />
    <Reviews />
    <Faq />
    <Booking />
  </main>
);

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 400);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      initLenis();
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <div id="top" className="bg-[#0A1128] text-slate-50 min-h-screen antialiased">
          <div className="grain-overlay" aria-hidden="true" />
          <ScrollManager />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          </Routes>
          <Footer />
          <FloatingContact />
          <ChatWidget />
          <Toaster theme="dark" position="top-center" />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
